import { lazy } from 'react'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'

import { ViewTypeProvider } from '@/modules/shared/contexts/view-type/ViewTypeProvider'
import AppLayout from '@/modules/shared/layouts/app-layout/AppLayout'
import NotFound from '@/modules/shared/pages/not-found/NotFound'
import { ViewType } from '@/modules/shared/types/ViewType'

const SystemSettingsRoutes = lazy(() => import('@/routes/shared-routes/SystemSettingsRoutes'))
const UserRoutes = lazy(() => import('@/routes/shared-routes/UserRoutes'))
const MyAccountRoutes = lazy(() => import('@/routes/shared-routes/MyAccountRoutes'))
const PurchaserDirectoryRoutes = lazy(() => import('@/routes/shared-routes/PurchaserDirectoryRoutes'))
const MyPurchasersRoutes = lazy(() => import('@/routes/shared-routes/MyPurchasersRoutes'))
const UtilityRoutes = lazy(() => import('@/routes/shared-routes/UtilityRoutes'))
const ShopRoutes = lazy(() => import('@/routes/public-routes/ShopRoutes'))
const BarcodeRoutes = lazy(() => import('@/routes/shared-routes/BarcodeRoutes'))
const Dashboard = lazy(() => import('@/modules/supplier/pages/dashboard/Dashboard'))
const CatalogRoutes = lazy(() => import('@/routes/shared-routes/CatalogRoutes'))
const PurchaseOrderRoutes = lazy(() => import('@/routes/shared-routes/PurchaseOrderRoutes'))
const InvoiceRoutes = lazy(() => import('@/routes/shared-routes/InvoiceRoutes'))
const CreditNoteRoutes = lazy(() => import('@/routes/shared-routes/CreditNoteRoutes'))
const ProductRoutes = lazy(() => import('@/routes/shared-routes/ProductRoutes'))
const QuoteRoutes = lazy(() => import('@/routes/shared-routes/QuoteRoutes'))
const ReportRoutes = lazy(() => import('@/routes/shared-routes/ReportRoutes'))
const OrganisationTagRoutes = lazy(() => import('@/routes/shared-routes/OrganisationTagRoutes'))

function SupplierContext() {
  return (
    <ViewTypeProvider viewType={ViewType.Supplier}>
      <Outlet />
    </ViewTypeProvider>
  )
}

export default function SupplierRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" />} />

      <Route element={<AppLayout />}>
        <Route element={<SupplierContext />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/purchaser-directory/*" element={<PurchaserDirectoryRoutes />} />
          <Route path="/my-purchasers/*" element={<MyPurchasersRoutes />} />
          <Route path="/my-account/*" element={<MyAccountRoutes />} />
          <Route path="/products/*" element={<ProductRoutes />} />
          <Route path="/catalogs/*" element={<CatalogRoutes />} />
          <Route path="/barcodes/*" element={<BarcodeRoutes />} />
          <Route path="/users/*" element={<UserRoutes />} />
          <Route path="/settings/*" element={<SystemSettingsRoutes />} />
          <Route path="/purchase-orders/*" element={<PurchaseOrderRoutes />} />
          <Route path="/invoices/*" element={<InvoiceRoutes />} />
          <Route path="/credit-notes/*" element={<CreditNoteRoutes />} />
          <Route path="/quotes/*" element={<QuoteRoutes />} />
          <Route path="/reports/*" element={<ReportRoutes />} />
          <Route path="/purchaser-tags/*" element={<OrganisationTagRoutes />} />
        </Route>
        <Route path="/utilities/*" element={<UtilityRoutes />} />
        <Route path="/shop/*" element={<ShopRoutes />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}
